const psProperties = {
    firstSeenAt: 'ps_first_seen_at',
    startSlug: 'ps_start_slug',
    startPage: 'ps_start_page',
    endSlug: 'ps_end_slug',
    convertedAt: 'ps_converted_at',
    completedAt: 'ps_completed_at',
    closedAt: 'ps_closed_at',
    lastSeenAt: 'ps_last_seen_at',
    isConverted: 'ps_converted',
    isCompleted: 'ps_completed',
    isClosed: 'ps_closed',
    result: 'ps_result_page',
    calendlyBook: 'ps_calendly_booked',
    cookies: 'ps_cookies',
    isEmbed: 'ps_embed',
    timezone: 'ps_timezone',
} as const;

export default psProperties;
